/**
 * Ищет элемент с id, указанным в якоре. При нахождении скроллит экран к нему.
 */
export default function scrollToAnchorByUrlHash() {
    const hash = window.location.hash.replace('#', '');
    if (hash != '') {
        scrollToAnchor(hash);
    }
}

const PLANK_MOBILE_HEIGHT = 72;
const NEW_MENU_HEIGHT = 72;

export function scrollToAnchor(anchor: string, additionalOffset = NEW_MENU_HEIGHT) {
    const el = document.getElementById(anchor);
    const phoneMenu = document.getElementById('MenuPhone');
    const plankMobile = document.getElementById('plankMobile');
    if (el) {
        let top = el.getBoundingClientRect().top;
        if (phoneMenu) {
            top -= phoneMenu.offsetHeight;
        }
        if (plankMobile) {
            top -= PLANK_MOBILE_HEIGHT;
        }
        window.scrollTo({
            behavior: 'smooth',
            top: top + window.pageYOffset - additionalOffset,
        });
    }
}
